<template>
  <LayoutEdit>
    <gdlFormDSL
      :fields="fields"
      :init-data="resource.one"
      :action="actionUpdateResource"
      @cancel="onCancel"
    />
  </LayoutEdit>
</template>

<script>
import { get, keyBy } from 'lodash';

import pageComponent from '@/mixins/page-component';

import http from '@/http';

import gdlFormDSL from '@/components/gdl/FormDSL.vue';
import LayoutEdit from './layouts/LayoutEdit.vue';

export default {
  name: 'RestResourcesIdEditPage',
  components: { LayoutEdit, gdlFormDSL },
  mixins: [pageComponent],
  inject: ['config'],
  props: {
    id: { type: String, required: true },
  },
  // beforeRouteLeave(to, from, next) {
  //   const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
  //   if (answer) { next() } else { next(false) }
  // },
  metaInfo() {
    const { title } = this.$pageComponentRoute.meta;
    const label = get(this.resource.one, this.config.route.key);
    return label ? { title: this.$t(title, { label }) } : { title: '...' };
  },
  breadcrumb() {
    const { breadcrumb } = this.$pageComponentRoute.meta;
    const label = get(this.resource.one, this.config.route.key);
    return {
      label: label ? this.$t(breadcrumb.i18n, { label }) : '',
      loading: !label,
    };
  },
  data() {
    const { fields } = this.config.form;
    return {
      fields,
    };
  },
  computed: {
    namespace() { return `${this.config.store.namespace}/${this.id}`; },
    resource() { return get(this.$store.state, this.namespace.split('/')); },
    fieldsBy() { return keyBy(this.fields, 'name'); },
  },
  methods: {
    async updateResource({ data }) {
      return this.$store.dispatch(`${this.namespace}/updateResource`, { data });
    },
    async actionUpdateResource({ data }) {
      try {
        const { lockVersion } = this.resource.one;
        await this.updateResource({ data: { ...data, lockVersion } });
        this.afterUpdateResource();
        return false;
      } catch (error) {
        if (http.isUnprocessableEntity(error)) {
          const { errors } = error.response.data;
          return errors;
        }
        throw error;
      }
    },
    afterUpdateResource() {
      const { name } = this.config.route;
      const { id } = this.resource.one;
      this.$router.push({ name: `${name}-id`, params: { id } });
    },
    onCancel() {
      const { name } = this.config.route;
      const { id } = this.resource.one;
      // ToDo back or id
      this.$router.push({ name: `${name}-id`, params: { id } });
    },

  },
};
</script>
